/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.gen.ai.skills.rpc.QuizMeRpc
 */

export const asyncBulkGenerateQuizMeRpc = {
  serviceName: 'com.hubspot.academy.gen.ai.skills.rpc.QuizMeRpc',
  rpcName: 'asyncBulkGenerateQuizMe',
  auth: 'app',
  fingerprint: '5FWjAbZNLkoUUwPALc7qQpO0m9sagqtq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const asyncBulkGetQuizMeRpc = {
  serviceName: 'com.hubspot.academy.gen.ai.skills.rpc.QuizMeRpc',
  rpcName: 'asyncBulkGetQuizMe',
  auth: 'app',
  fingerprint: 'F0rU8QgGkZO_nt94748VxZO0m9sagqtq',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};